/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HealthcheckService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Status Get
     * Fast check to ensure API is running.
     * 🏴‍☠️ DO NOT CHANGE 🏴‍☠️
     * This is used in a lot of infrastructure:
     * nginx
     * telemetry
     * aws load balancer
     * deploy scripts
     *
     * Runs as ``async def`` so it stays on the event loop instead of the AnyIO
     * worker thread pool. A zero-I/O liveness probe must never queue behind a
     * saturated sync thread pool, or the LB could mark a healthy instance down.
     * Keep the response body/headers/status byte-identical (infra depends on them).
     * @returns string Successful Response
     * @throws ApiError
     */
    public statusGet(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/healthcheck/api',
        });
    }

    /**
     * Database Health Check
     * Fast check to ensure database connectivity.
     * Returns status of read-only and regular database connections.
     * @returns string Successful Response
     * @throws ApiError
     */
    public databaseHealthCheck(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/healthcheck/database',
        });
    }

}
